import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';
import { SessionService } from 'app/components/common/session/session.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';

@Injectable({
  providedIn: 'root'
})
export class MenuExhibitorSubMenuService {

  constructor(private http: HttpClient, private sessionService: SessionService, private catalogueService: CatalogueService) { }

  setData(data) {
    let nameStorage = `backofficeExhibitor_${this.catalogueService.getProperty('sapCode')}`;
    this.sessionService.set(nameStorage, data, true);
  }

  getData() {
    let nameStorage = `backofficeExhibitor_${this.catalogueService.getProperty('sapCode')}`;
    return JSON.parse(this.sessionService.get(nameStorage, true) || '{}');
  }

  getProperty(property) {
    return this.getData()[property] || null;
  }

}
